import { Button } from '@acpaas-ui/react-components';
import { useState } from 'react';
import { useParams } from 'react-router-dom';
import AttachmentsList from '../../../components/attachments/AttachmentsList';
import DossierSectionWrapper from '../../../components/dossier-details/DossierSectionWrapper';
import TextField from '../../../components/forms/TextField';
import { MODALS } from '../../../constants/modals.constants';
import { ATTACHMENT_TYPES } from '../../../constants/settings.constants';
import { TEMPLATE_CATEGORIES_SUFFIXES } from '../../../constants/templates.constants';
import { useAttachmentCRUD } from '../../../hooks/useAttachmentCRUD.hook';
import { useModal } from '../../../hooks/useModal.hook';
import { userToString } from '../../../lib/auth.utils';
import { dateToDateString } from '../../../lib/date.utils';
import { getAttachmentsForRequest } from '../../../lib/dossier.utils';
import { formSnapshotToData } from '../../../lib/form.utils';
import { getTemplateCategory } from '../../../lib/template.utils';
import AttachmentDetailsModal from '../../../modals/AttachmentDetailsModal';
import AttachmentUploadModal from '../../../modals/AttachmentUploadModal';
import DeleteWarningModal from '../../../modals/DeleteWarningModal';
import AddSchoolToRequestModal from '../../../modals/dossier/AddSchoolToRequestModal';
import DeleteSchoolFromRequestModal from '../../../modals/dossier/DeleteSchoolFromRequestModal';
import { DOSSIER_OVERVIEW_SCHOOLS_RESOURCE } from '../../../resources/dossier.overview.schools.resource';
import { FORMS_ENGINE_DOSSIER_REQUEST_FORM_VIEW_RESOURCE } from '../../../resources/forms.engine.form.view.resource';
import StaticTable from '../../core/StaticTable';
import DossierTemplates from '../../dossier-templates/DossierTemplates';
import FormViewWidget from '../../forms-engine/FormsEngineView';

const DossierDetailRequest = ({ data, attachments, isLoadingAttachments, onDossierRefetch, onAttachmentsRefetch }) => {
  const params = useParams();
  const attachmentCRUD = useAttachmentCRUD(params.id);
  const schoolAddModal = useModal(MODALS.ADD_SCHOOL_TO_REQUEST_MODAL);
  const schoolDeleteModal = useModal(MODALS.DETAIL_SCHOOL_FROM_REQUEST_MODAL);
  const [schoolDeleteModalData, setSchoolDeleteModalData] = useState({});

  const handleOnDeleteSchoolClick = (data) => {
    setSchoolDeleteModalData(data);
    schoolDeleteModal.onOpen();
  };

  const handleOnAddSchoolClick = () => {
    schoolAddModal.onOpen();
  };

  return (
    <div>
      <div className="row u-margin-bottom-xs">
        <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
          <TextField label="Aanvraagdatum" readOnly value={dateToDateString(data?.request?.submitDate)} />
        </div>
        <div className="col-xs-12 col-md-6 col-lg-3 u-margin-bottom-xs">
          <TextField label="Aangevraagd door" readOnly value={userToString(data?.request?.submittedBy)} />
        </div>
      </div>
      <StaticTable
        resource={DOSSIER_OVERVIEW_SCHOOLS_RESOURCE}
        data={data?.overview?.school}
        onRowClick={handleOnDeleteSchoolClick}
        actions={[
          <Button
            key="add-school-request"
            iconRight="ai-add"
            size="small"
            className="u-margin-right-xs"
            onClick={handleOnAddSchoolClick}
          >
            School toevoegen
          </Button>
        ]}
        responsive
      />
      {data?.request?.formSlug && (
        <DossierSectionWrapper
          items={[
            {
              title: 'Aanvraagformulier',
              Component: (
                <FormViewWidget
                  slug={data?.request?.formSlug}
                  formData={formSnapshotToData(data?.request?.form)}
                  formSnapshot={data?.request?.form}
                  resource={FORMS_ENGINE_DOSSIER_REQUEST_FORM_VIEW_RESOURCE}
                />
              )
            }
          ]}
        />
      )}
      <div className="row u-margin-top-lg">
        <div className="col-xs-12">
          <AttachmentsList
            title="Bestanden"
            loading={isLoadingAttachments}
            attachments={getAttachmentsForRequest(attachments)}
            noAttachmentsText="Er zijn momenteel nog geen bestanden toegevoegd."
            onOpen={attachmentCRUD.onAttachmentOpen}
            onUpload={() => attachmentCRUD.onAttachmentAddOpen('', ATTACHMENT_TYPES.REQUEST)}
            templates={
              <DossierTemplates category={getTemplateCategory(data?.type, TEMPLATE_CATEGORIES_SUFFIXES.REQUEST)} />
            }
          />
        </div>
      </div>
      <AttachmentUploadModal {...attachmentCRUD.uploadModal} onConfirm={attachmentCRUD.onAttachmentAdd} />
      <AttachmentDetailsModal
        {...attachmentCRUD.detailsModal}
        dossierId={params.id}
        form={attachmentCRUD.attachmentDetailForm}
        onUpdate={attachmentCRUD.onAttachmentUpdate}
        onUpdateSuccess={onAttachmentsRefetch}
        onDelete={attachmentCRUD.deleteModal.onOpen}
      />
      {attachmentCRUD.deleteModal.isOpen && (
        <DeleteWarningModal
          {...attachmentCRUD.deleteModal}
          warningText="Weet je zeker dat je deze bijlage wilt verwijderen?"
          onConfirm={attachmentCRUD.onAttachmentDelete}
        />
      )}
      {schoolAddModal.isOpen && (
        <AddSchoolToRequestModal
          {...schoolAddModal}
          dossierId={params.id}
          onUpdated={onDossierRefetch}
          dossierOverviewData={data?.overview}
        />
      )}
      {schoolDeleteModal.isOpen && (
        <DeleteSchoolFromRequestModal
          {...schoolDeleteModal}
          dossierId={params.id}
          data={schoolDeleteModalData}
          onUpdated={onDossierRefetch}
          dossierOverviewData={data?.overview}
        />
      )}
    </div>
  );
};

export default DossierDetailRequest;
